__turbopack_context__.v({
  "container": "TopBar-module__UGQJGG__container",
  "leftSection": "TopBar-module__UGQJGG__leftSection",
  "rightSection": "TopBar-module__UGQJGG__rightSection",
  "settings": "TopBar-module__UGQJGG__settings",
  "topBar": "TopBar-module__UGQJGG__topBar",
});
